/* stylelint-disable selector-class-pattern -- global Ant / kebab third-party classes */

.formStyledFields() {
  :global {
    .ant-form-item-label {
      padding-bottom: 2px;
      font-weight: 600;

      --ant-form-vertical-label-padding: 0 0 2px 0;
    }

    .ant-form-item-has-error.ant-form-item-hidden {
      display: block;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }

    .ant-switch-checked {
      background-color: var(--x-color-action);
    }

    .ant-form-item {
      margin-bottom: 8px;
    }

    /* stylelint-disable declaration-no-important */

    .ant-form-autocomplete .ant-select-selector {
      height: 32px !important;
      padding: 4px 7px !important;
    }
    /* stylelint-enable declaration-no-important */

    .ant-form-autocomplete label {
      width: 100%;
    }

    .ant-collapse:not(.ant-collapse-ghost) .ant-collapse-header {
      background-color: var(--x-color-background);
    }

    .partners-selector .partners-selector-filters {
      margin-top: 14px;
    }

    label {
      .ant-btn-link {
        height: 22px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    .ant-btn-link,
    a {
      color: var(--x-color-action);
    }

    .ant-table-thead .ant-table-cell {
      font-weight: 600;
    }

    .statistic-grid {
      /* landmine: ":first-of-child" is an invalid pseudo-class (typo for :first-of-type) carried over verbatim from the original styled source; preserved to keep the existing non-matching behavior (do NOT "fix") */
      /* stylelint-disable selector-pseudo-class-no-unknown */

      .ant-col:first-of-child {
        margin-right: 18px;
      }
      /* stylelint-enable selector-pseudo-class-no-unknown */

      .ant-col + .ant-col {
        padding-left: 18px;
        border-left: 1px solid var(--x-color-border);
      }
    }
  }
}

.formWrapper() {
  .formStyledFields();

  max-width: 1100px;
  margin: 0 auto;
  color: var(--x-color-text-primary-darker);
}

.formStyledFields {
  .formStyledFields();
}

.formWrapper {
  .formWrapper();
}

.formStyled {
  .formWrapper();

  :global {
    .ant-form-item-label {
      font-weight: 600;
    }

    .ant-form-item {
      margin-bottom: 5px;
    }

    .ant-form-item-control-input {
      min-height: 24px;
    }
  }
}

.label {
  margin-bottom: 0;
  cursor: pointer;
}

.formGroupLabel {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 0;
  font-weight: 600;

  > div {
    padding-top: 10px;
  }

  button {
    padding-right: 0;
  }
}

.formGroupHr {
  height: 1px;
  border: 0;
  margin-top: 0;
  margin-bottom: 10px;
  background-color: var(--x-color-border);
}

.formItemBlock {
  margin-bottom: 15px;
}
